module.exports = __webpack_public_path__ + "assets/img/bg6.718b1b84.gif";